import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '../../resources/submission';
import {IConfigSchema,} from '../../resources/config-schema';
import {getIndicators} from './calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'I. GIORNATE AGGREGATIVE PRESSO I CENTRI SOCIO RICREATIVI',
    tooltip: 'Il visual mostra il confronto fra:' +
        '<li>il numero possibili interventi di manutenzione mappati e il corrispondente valore atteso per il progetto;</li>' +
        '<li>il numero di abitazioni in cui è stato effettivamente realizzato almeno un intervento di manutenzione e il corrispondente valore atteso per il progetto;</li>' +
        '<li>il numero di iniziative culturali e sociali promosse sul territorio</li>',
    type: 'column',
    categories: ['Giornate aggregative presso i centri socio ricreativi', 'Incontri di socialità presso le sedi della custodia sociale', 'Iniziative culturali e sociali promosse sul territorio'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: getIndicators(submissions)
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [75, 25, 15]
        },
    ],
});